/**
 * @file   src\components\Introduction\SuccessModal.js
 * @brief  This file is responsible for the view of success modal after introduction send
 * @date   April, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */
import React from "react";
import Modal from "react-bootstrap/Modal";
import { Row, Col, Button } from "react-bootstrap";
import FireWorkImgTop from "../../images/party-popper.png";
import { useNavigate } from "react-router-dom";
import { pageURLs } from "@/constants";

const SuccessModal = (props) => {

  return (
    <Modal
      show
      centered
      {...props}
      size="sm"
      aria-labelledby="contained-modal-title-vcenter"
      className="modal-width-372"
    >
      <Modal.Body className="pt-100 pb-32 pl-30 pr-30">
        <div className="fireworks-overlay-top top-82">
          <div className="pyro pyro-left-top">
            <div className="before"></div>
            <div className="after"></div>
          </div>
          <img
            className="mw-48"
            src={FireWorkImgTop}
            width={"48px"}
            height={"48px"}
          />
        </div>
        <h3 className="text-center mt-5">Introduction sent </h3>
        <Row>
          <Col xl={12} className="">
            <p className=" mb-5 f-size-16 text-center">
              We'll keep you updated on your introduction status. When they
              accept it, they'll have 72 hours to send you a message. Good luck!
            </p>
          </Col>
          <Col xl={12} className="">
            <div className="modal-btn-wrap">
              <Button
                variant="primary"
                className="btn w-100"
                onClick={() => {
                  props.onHide();
                }}
              >
                Done
              </Button>
            </div>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};
export default SuccessModal;
